<script setup lang="ts">
import { IonIcon, IonLabel, IonTabBar, IonTabButton } from '@ionic/vue';
import { addIcons } from 'ionicons';
import {
  calendarOutline,
  homeOutline,
  megaphoneOutline,
  newspaperOutline,
} from 'ionicons/icons';

import moreIcon from '@/assets/img/icons/more.svg';
import { useTabRootNavigation } from '@/composables/useTabRootNavigation';
import { ENTITIES } from '@/constants';

addIcons({
  more: moreIcon,
});

const { handleTabBarClick } = useTabRootNavigation();
</script>

<template>
  <ion-tab-bar
    slot="bottom"
    @click.capture="handleTabBarClick"
  >
    <ion-tab-button
      tab="home"
      href="/start"
    >
      <ion-icon :icon="homeOutline" />
      <ion-label>Home</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="news"
      :href="`/${ENTITIES.NEWS.PATH}`"
    >
      <ion-icon :icon="newspaperOutline" />
      <ion-label>News</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="notes"
      :href="`/${ENTITIES.HINT.PATH}`"
    >
      <ion-icon :src="megaphoneOutline" />
      <ion-label>Hinweise</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="events"
      :href="`/${ENTITIES.EVENT.PATH}`"
    >
      <ion-icon :icon="calendarOutline" />
      <ion-label>Events</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="pages"
      :href="`/${ENTITIES.PAGE.PATH}`"
    >
      <ion-icon name="more" />
      <ion-label>Mehr</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</template>
